 import { IInvetigation } from '../interface/invetigation';
export class Investigation implements IInvetigation {
    constructor(public InvestigationId : number, public InvestigationDetail : string){
    }
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/investigation.ts